<template>
  <Modal :classes="classes" @overlayClick="cancelModal">
    <template #header>{{title}}</template>
    <slot></slot>

    <template #footer>
      <slot name="footer"></slot>
    </template>
  </Modal>
</template>

<script>
import KeyCombo from '@/services/keycombo/KeyComboService';
import ModalMixin from '../ModalMixin';

export default {
  name: 'ModalChallenge',
  mixins: [
    ModalMixin,
  ],
  props: {
    title: {
      type: String,
    },
    isDanger: {
      type: Boolean,
      default: false,
    },
    isValid: {
      type: Boolean,
      default: true,
    },
    classes: {
      type: Array,
      default: () => ([]),
    },
  },
  computed: {
    btnClasses() {
      return this.isDanger ? ['btn--danger'] : ['btn--accent'];
    },
  },
  mounted() {
    KeyCombo.newCombo('ModalChallenge.Esc', [27], this.onEscape);
  },
  methods: {
    cancelModal() {
      this.$emit('close', false);
    },
    confirmModal() {
      this.$emit('close', true);
    },
    onEscape() {
      this.$emit('close', false);
    },
  },
  beforeUnmount() {
    KeyCombo.removeCombo('ModalChallenge.Esc');
  },
};
</script>
